import React from "react";
import dcfooter from './footer.module.css';
import linkedinImg from '../../Images/SocialMedia/linkedin.png';
import xImg from '../../Images/SocialMedia/twitter.png';
import igImg from '../../Images/SocialMedia/instagram.png';
import fbImg from '../../Images/SocialMedia/facebook.png';
import dablerLogo from "../../../CommonImages/dabler4.png";
import { socialLinks } from "../../../../App";
import { Link } from "react-router-dom";

export default function Footer(props){

    return (
        <>
          <div className={dcfooter["footer-real-top"]}>
            <div className={dcfooter["footer-top"]}>
                <div className={dcfooter["company-details"]}>
                    <div className={dcfooter["about-company"]}>
                        <img src={dablerLogo} alt="dabler" />
                    </div>
                    <div className={dcfooter["company-add"]}>
                        <h4>Address</h4>
                        <p>128 City Road, London,<br/> United Kingdom, EC1V 2NX</p>
                    </div>
                    <div className={dcfooter["company-email"]}>
                        <div className={dcfooter["email-texts"]}>
                            <h4>Email</h4>
                            <p>dabler@dabler.co.uk</p>
                        </div>
                    </div> 
                </div>

                <div className={`${dcfooter["about-products"]} ${dcfooter["dc-f-head-pad"]}`}>
                    <div className={dcfooter["footer-col-head"]}>Quick Links</div>
                    {/* <a href="#">Documentation</a>
                    <a href="#">Blogs</a> */}
                    <Link to={'/'}>Dabler</Link>
                    <Link to={'/snippetflow'}>SnippetFlow</Link>
                    <Link to={'/acuber'}>Acuber AI</Link>
                </div>

                <div className={`${dcfooter["social-media"]} ${dcfooter["dc-f-head-pad"]}`}>
                    <div className={dcfooter["footer-col-head"]}>Social Media</div>
                    <div className={dcfooter["social-container"]}>
                        <a href={socialLinks.linkedIn}><img src={linkedinImg} alt="linkedIn" className={dcfooter["social-icon"]}/></a>
                        {/* <a href={socialLinks.x}><img src={xImg} alt="x" className={dcfooter["social-icon"]}/></a> */}
                        <a href={socialLinks.fb}><img src={fbImg} alt="fb" className={dcfooter["social-icon"]}/></a>
                        {/* <a href={socialLinks.ig}><img src={igImg} alt="ig" className={dcfooter["social-icon"]}/></a> */}
                    </div>
                </div>
            </div>
            
            <div className={dcfooter["copyright"]}>
                <p className="mbr-text mb-0 mbr-fonts-style display-7">© Copyright DABLER - All Rights Reserved</p>
            </div>
          </div>
        </>
    )
}